import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useFetchCampaigns } from "../utils/useFetchCampaigns";
import "../assets/css/CampaignDetail.css";

function CampaignDetail() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const clientName = localStorage.getItem("selectedClientName") || "Cliente";
  const token = sessionStorage.getItem("REACT_APP_TOKEN");

  const { allCampaigns, campaign, rawCampaign } = state || {};
  const [currentCampaign, setCurrentCampaign] = useState(campaign);
  const [currentRawCampaign, setCurrentRawCampaign] = useState(rawCampaign);

  const [selectedFunil, setSelectedFunil] = useState("funilEcommerce");
  const [selectedValue, setSelectedValue] = useState("");

  const [comparison, setComparison] = useState({});
  const [diffPercentages, setDiffPercentages] = useState({});

  const [insightMessage, setInsightMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [isCampaignDropdownOpen, setIsCampaignDropdownOpen] = useState(false);

  const {
    averages,
    totalAverages,
    rawCampaigns,
  } = useFetchCampaigns(selectedFunil);

  const { ctr, cpc, name, compras, roas } = currentCampaign || {};

  const calculateComparison = (campaign) => {
    if (!campaign || !averages) return;

    const metrics = ['cpc', 'ctr', 'compras', 'roas'];
    const newComparison = {};
    const newDiffPercentages = {};

    metrics.forEach((metric) => {
      const campaignValue = parseFloat(campaign[metric]);
      const averageValue = parseFloat(averages[`avg${metric.charAt(0).toUpperCase() + metric.slice(1)}`]);

      if (!isNaN(campaignValue) && !isNaN(averageValue)) {
        newComparison[metric] = campaignValue >= averageValue ? 'acima' : 'abaixo';
        const diff = ((campaignValue - averageValue) / averageValue) * 100;
        newDiffPercentages[metric] = diff;
      } else {
        newComparison[metric] = 'N/A';
        newDiffPercentages[metric] = 0;
      }
    });

    setComparison(newComparison);
    setDiffPercentages(newDiffPercentages);
  };

  const getComparisonClassFromLine = (line) => {
    const lower = line.toLowerCase();
    if (lower.includes("acima")) return "text-positive";
    if (lower.includes("abaixo")) return "text-negative";
    return "";
  };

  const metricMapping = {
    ctr: "ctr",
    cpc: "cpc",
    roas: "roas",
    compras: "compras",
    "valor da conversão": null,
    "ticket médio": null,
    "taxa de conversão": null,
    "valor usado": null,
  };

  const generateInsight = async () => {
    if (!campaign || !averages || !rawCampaign) return;

    setLoading(true);

    const body = {
      averages: totalAverages,
      campaigns: [currentRawCampaign],
    };

    try {
      const response = await fetch(
        "https://ad-insights-api-0f2fcea0deda.herokuapp.com/api/campaign-insight/fetch",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );

      const insightData = await response.json();

      if (insightData?.data) {
        setInsightMessage(insightData.data);
      }
    } catch (error) {
      console.error("Erro ao gerar o insight:", error);
    } finally {
      setLoading(false);
    }
  };

  const insights = insightMessage
    ? insightMessage.split(/\n\s*\n/).filter(item => item.trim() !== "")
    : [];

  useEffect(() => {
    if (currentCampaign && averages) {
      calculateComparison(currentCampaign);
    }
  }, [currentCampaign, averages]);

  return (
    <div className="campaign-analysis">
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap"
        rel="stylesheet"
      />
      <link
        href="https://cdn.jsdelivr.net/npm/@tabler/icons@1.68.0/iconfont/tabler-icons.min.css"
        rel="stylesheet"
      />

      <div className="breadcrumb-container">
        <div className="breadcrumb-path">
          <div className="breadcrumb-item">
            <span className="breadcrumb-text" onClick={() => navigate("/team")}>Clientes</span>
            <div className="breadcrumb-arrow">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.72725 13.1477C6.50758 12.9281 6.50758 12.5719 6.72725 12.3523L10.0795 9L6.72725 5.64775C6.50758 5.42808 6.50758 5.07192 6.72725 4.85225C6.94692 4.63258 7.30308 4.63258 7.52275 4.85225L11.2727 8.60225C11.3782 8.70774 11.4375 8.85082 11.4375 9C11.4375 9.14918 11.3782 9.29226 11.2727 9.39775L7.52275 13.1477C7.30308 13.3674 6.94692 13.3674 6.72725 13.1477Z"
                  fill="#364152"
                />
              </svg>
            </div>
          </div>
          <div className="breadcrumb-item">
            <span className="breadcrumb-text" onClick={() => navigate("insights")}>{clientName}</span>
            <div className="breadcrumb-arrow">
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M6.72725 13.1477C6.50758 12.9281 6.50758 12.5719 6.72725 12.3523L10.0795 9L6.72725 5.64775C6.50758 5.42808 6.50758 5.07192 6.72725 4.85225C6.94692 4.63258 7.30308 4.63258 7.52275 4.85225L11.2727 8.60225C11.3782 8.70774 11.4375 8.85082 11.4375 9C11.4375 9.14918 11.3782 9.29226 11.2727 9.39775L7.52275 13.1477C7.30308 13.3674 6.94692 13.3674 6.72725 13.1477Z"
                  fill="#364152"
                />
              </svg>
            </div>
          </div>
          <div className="breadcrumb-current">Análise</div>
        </div>
        <div className="filter-controls-container">
          <div className="campaign-filter">
            <div className="date-range" onClick={() => setIsCampaignDropdownOpen(prev => !prev)}>
              {selectedValue || name}
            </div>
            <div className="dropdown-button" onClick={() => setIsCampaignDropdownOpen(prev => !prev)}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path
                  d="M7 10L12 15M12 15L17 10"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>

            {isCampaignDropdownOpen && (
              <div className={`date-dropdown ${allCampaigns.length > 5 ? 'with-scroll' : ''
                }`}>
                {allCampaigns.map((c) => (
                  <div
                    key={c.id}
                    className="date-option"
                    onClick={() => {
                      const selectedCampaign = allCampaigns.find((camp) => camp.name === c.name);
                      const selectedRawCampaign = rawCampaigns.find((camp) => camp.nomeDaCampanha === c.name);

                      setCurrentCampaign(selectedCampaign);
                      setCurrentRawCampaign(selectedRawCampaign);
                      calculateComparison(selectedCampaign);
                      setSelectedValue(c.name);
                      setIsCampaignDropdownOpen(false);
                    }}
                  >
                    {c.name}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="metrics-grid">
        <div className="metric-card">
          <div className="metric-label">CPC</div>
          <div className="metric-values">
            <div className="metric-current">{cpc !== undefined ? parseFloat(cpc).toFixed(2).replace('.', ',') : 'N/A'}</div>
            <div className="metric-average">Média de R${totalAverages?.cpc}</div>
          </div>
          <div className="metric-comparison">
            <div className={`comparison-icon ${comparison?.cpc === "acima" ? "positive" : "negative"}`}>
              {comparison?.cpc === "acima" ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z" fill="#0CB83A"></path>
                </svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 18L18.29 15.71L13.41 10.83L9.41 14.83L2 7.41L3.41 6L9.41 12L13.41 8L19.71 14.29L22 12V18H16Z" fill="#F34242"></path>
                </svg>
              )}
            </div>
            <div className={`comparison-text ${comparison?.cpc === "acima" ? "positive" : "negative"}`}>  {Math.abs(diffPercentages.cpc ?? 0).toFixed(2)}%</div>
            <span className={`comparison-text ${comparison?.cpc === "acima" ? "positive" : "negative"}`}>
              {comparison?.cpc === "acima" ? "Acima da média" : "Abaixo da média"}
            </span>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-label">CTR</div>
          <div className="metric-values">
            <div className="metric-current">{ctr !== undefined ? parseFloat(ctr).toFixed(2).replace('.', ',') : 'N/A'}</div>
            <div className="metric-average">Média de {totalAverages?.ctr}</div>
          </div>
          <div className="metric-comparison">
            <div className={`comparison-icon ${comparison?.ctr === "acima" ? "positive" : "negative"}`}>
              {comparison?.ctr === "acima" ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z" fill="#0CB83A"></path>
                </svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 18L18.29 15.71L13.41 10.83L9.41 14.83L2 7.41L3.41 6L9.41 12L13.41 8L19.71 14.29L22 12V18H16Z" fill="#F34242"></path>
                </svg>
              )}
            </div>
            <div className={`comparison-text ${comparison?.ctr === "acima" ? "positive" : "negative"}`}>{Math.abs(diffPercentages.ctr ?? 0).toFixed(2)}%</div>
            <span className={`comparison-text ${comparison?.ctr === "acima" ? "positive" : "negative"}`}>
              {comparison?.ctr === "acima" ? "Acima da média" : "Abaixo da média"}
            </span>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-label">Compras</div>
          <div className="metric-values">
            <div className="metric-current">{compras !== undefined ? parseFloat(compras).toFixed(2).replace('.', ',') : 'N/A'}</div>
            <div className="metric-average">Média de R${totalAverages?.compras}</div>
          </div>
          <div className="metric-comparison">
            <div className={`comparison-icon ${comparison?.compras === "acima" ? "positive" : "negative"}`}>
              {comparison?.compras === "acima" ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z" fill="#0CB83A"></path>
                </svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 18L18.29 15.71L13.41 10.83L9.41 14.83L2 7.41L3.41 6L9.41 12L13.41 8L19.71 14.29L22 12V18H16Z" fill="#F34242"></path>
                </svg>
              )}
            </div>
            <div className={`comparison-text ${comparison?.compras === "acima" ? "positive" : "negative"}`}>{Math.abs(diffPercentages.compras ?? 0).toFixed(2)}%</div>
            <span className={`comparison-text ${comparison?.compras === "acima" ? "positive" : "negative"}`}>
              {comparison?.compras === "acima" ? "Acima da média" : "Abaixo da média"}
            </span>
          </div>
        </div>

        <div className="metric-card">
          <div className="metric-label">Roas</div>
          <div className="metric-values">
            <div className="metric-current">{roas !== undefined ? parseFloat(roas).toFixed(2).replace('.', ',') : 'N/A'}</div>
            <div className="metric-average">Média de {totalAverages?.roas}</div>
          </div>
          <div className="metric-comparison">
            <div className={`comparison-icon ${comparison?.roas === "acima" ? "positive" : "negative"}`}>
              {comparison?.roas === "acima" ? (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 6L18.29 8.29L13.41 13.17L9.41 9.17L2 16.59L3.41 18L9.41 12L13.41 16L19.71 9.71L22 12V6H16Z" fill="#0CB83A"></path>
                </svg>
              ) : (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16 18L18.29 15.71L13.41 10.83L9.41 14.83L2 7.41L3.41 6L9.41 12L13.41 8L19.71 14.29L22 12V18H16Z" fill="#F34242"></path>
                </svg>
              )}
            </div>
            <div className={`comparison-text ${comparison?.roas === "acima" ? "positive" : "negative"}`}>{Math.abs(diffPercentages.roas ?? 0).toFixed(2)}%</div>
            <span className={`comparison-text ${comparison?.roas === "acima" ? "positive" : "negative"}`}>
              {comparison?.roas === "acima" ? "Acima da média" : "Abaixo da média"}
            </span>
          </div>
        </div>
      </div>

      <div className="analysis-container">
        <div className="actions-card">
          <div className="actions-header">
            <div className="actions-title">Ações imediatas</div>
            <div className="actions-subtitle">
              Usamos inteligência artificial para sugerir a melhor opção para
              otimizar sua campanha
            </div>
          </div>
          <div className="actions-list">
            <button
              className="add-client-button"
              onClick={generateInsight}
            >
              Gerar Insight
            </button>
            {loading ? (
              <div className="action-item">
                <div className="action-header">
                  <div className="action-indicator">
                    <div className="action-status loader"></div>
                    <span className="action-title">Gerando insight...</span>
                  </div>
                </div>
              </div>
            ) : (
              insights.map((insight, index) => (
                <div key={index} className="action-item">
                  <div className="action-header">
                    <div className="action-indicator">
                      <div className="action-status"></div>
                      <span className="action-title">
                        {insight.split('\n').map((line, i) => {
                          const metricTitleMatch = line.match(/^(\d+)\.\s*([^:]+):/);
                          if (metricTitleMatch) {
                            const rawTitle = metricTitleMatch[2].toLowerCase().trim();
                            const metricKey = metricMapping[rawTitle] || null;

                            const comparisonClass =
                              metricKey === null ? "text-neutral" :
                                comparison?.[metricKey] === "acima" ? "text-positive" :
                                  comparison?.[metricKey] === "abaixo" ? "text-negative" :
                                    "text-neutral";

                            return (
                              <div key={i} className={comparisonClass}>
                                {line}
                              </div>
                            );
                          }

                          const boldMatch = line.match(/\*\*(Hipótese de ação de melhoria:)(.*?)\*\*/);
                          if (boldMatch) {
                            const [fullMatch, label, value] = boldMatch;
                            const [before, after] = line.split(fullMatch);
                            return (
                              <React.Fragment key={i}>
                                {before && <>{before}<br /></>}
                                <strong>{label}{value}</strong>
                                {after && <><br />{after}</>}
                                <br />
                              </React.Fragment>
                            );
                          }

                          return (
                            <div key={i}>
                              {line}
                            </div>
                          );
                        })}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default CampaignDetail;
